import logoIcon from '../../../assets/images/Tmo-Logo-White.svg';
import './header.css';


const Header = ()=> {
return (
    <div className="header-container">
        <div className="header">
            <div className="logo">
                <img src={logoIcon} alt="logo" />
                <span className='logo-text'>Magenta ID Verification</span>
            </div>
            
            <div className="user-details">
                <span className='user-name'>
                </span> 
            </div>
        </div>
    </div>
);
};

export default Header;